export default "__VITE_ASSET__Wo5$1jNT__"